package kz.dentalcrm.app.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Immutable
data class Offset(
    val offset: Dp = 4.dp,
    val half: Dp = offset.div(2),
    val one: Dp = offset.times(1),
    val two: Dp = offset.times(2),
    val three: Dp = offset.times(3),
    val four: Dp = offset.times(4),
    val five: Dp = offset.times(5),
    val six: Dp = offset.times(6),
    val eight: Dp = offset.times(8),
    val fourteen: Dp = offset.times(14)
)

val LocalThemeOffset = staticCompositionLocalOf { Offset() }

@Immutable
data class Spacing(

    val spacingZero: Dp = 0.dp,
    val spacingXXXSmall: Dp = 2.dp,
    val spacingXXSmall: Dp = 4.dp,
    val spacingXSmall: Dp = 8.dp,
    val spacingMSmall: Dp = 12.dp,
    val spacingSmall: Dp = 16.dp,
    val spacingMedium: Dp = 24.dp,
    val spacingLarge: Dp = 32.dp,
    val spacingLarge2: Dp = 48.dp,
    val spacingXLarge: Dp = 64.dp,
    val spacingXXLarge: Dp = 96.dp,
    val spacingXXXLarge: Dp = 128.dp,
    val spacingHuge: Dp = 196.dp,
    val spacingXHuge: Dp = 256.dp
)

val LocalThemeSpacing = staticCompositionLocalOf { Spacing() }

@Immutable
data class Borders(
    val bordersZero: Dp = 0.dp,
    val bordersXSmall: Dp = 4.dp,
    val bordersSmall: Dp = 8.dp,
    val bordersMedium: Dp = 12.dp,
    val bordersLarge: Dp = 16.dp,
    val bordersXLarge: Dp = 20.dp
)

val LocalThemeBorders = staticCompositionLocalOf { Borders() }


